module.exports = __webpack_public_path__ + "static/img/cc.9b2df7a7.svg";